import React, {Component} from 'react';
import './Modal.css'

class Modal extends Component{

    constructor(props) {
        super(props)
        this.state = {
            modalState: 'closed'
        }
    }

    handleClick = (e) => {
        e.preventDefault();
        if(e.target === e.currentTarget) {
            this.props.onRequestClose()
         }
    }

    afterOpen = () => {
        if(this.props.onAfterOpen) {
            if(this.state.modalState === 'open') {
                this.props.onAfterOpen()
            }
        }
    }

    async updateComponent() {
        this.setState(prevState => ({
            modalState: prevState.modalState === 'closed' ? 'open' : 'closed'
        }),() => this.afterOpen())
    }

    componentDidUpdate(prevProps) {
        if(prevProps.isOpen !== this.props.isOpen) {
            this.updateComponent();
        }
    }

    render() {
        return(
            <div className={`my-modal ${this.state.modalState}`} onClick={this.handleClick}>
                <div className={`modal-content ${this.props.className}`}>
                    {
                        this.state.modalState === 'open' &&
                        <span>
                            {this.props.children}
                        </span>
                    }
                </div>
            </div>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js